module.exports = __webpack_public_path__ + "static/media/14.8a2d15f4.png";